import React from "react";
import Layout from "components/Layout";
import { BackHeader } from "@xt/Nav";
import { Context, Hooks } from "@xt/xtbase";
import { getCommonStaticProps } from "@/utils/method";
import ThirdPartyBuyRecords from "@/components/Pages/Credit/ThirdPartyBuy/Records";

const { XtContext } = Context;
const { useTranslation } = Hooks;

export default function CreditRecordsPage() {
  const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const orderHistoryTitle = t("credit.OrderHistory");
  const headerTitle = !orderHistoryTitle || orderHistoryTitle === "credit.OrderHistory" ? "Order History" : orderHistoryTitle;

  return (
    <Layout isShowNav={false} isShowFoot={false} useBottomBar={false}>
      <BackHeader title={headerTitle} showHome />
      <ThirdPartyBuyRecords loginStatus={appState?.loginStatus} />
    </Layout>
  );
}

export async function getStaticProps(context) {
  return getCommonStaticProps(context, "/credit/records");
}
